import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {FormGroup, FormControl, ControlLabel} from 'react-bootstrap'
import {observer, inject} from 'mobx-react'
import '../components/css/OneLineTextField.css'

class OneLineTextField extends Component {
    // getIdeaNameValidationState() {
    //     if(this.props.name){
    //         const length = this.props.name.length
    //         if (length > 0) return 'success'
    //         else return 'error'
    //     }else{
    //         return 'error'
    //     }
    // }
    constructor(params) {
        super(params)
        this.state = {
            characterCount: 0,
            showStatus: false,
            showSaved: false,
            showSaving: false,
        }
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.name){
            this.setState({characterCount:nextProps.name.length})
        }
    }

    wordCount(e){
        var currentText = e.target.value
        this.setState({
            characterCount : currentText.length,
            showSaved: true,
        })
        this.props.onChange(currentText)
    }

    charAmount(){
        let char = null
        if (this.state.characterCount >= this.props.limit+1){
            char = <span style={{color: 'red'}}>{this.state.characterCount}/{this.props.limit}</span>
            return char
        }
        else if (this.state.characterCount <= this.props.limit){
            char = <span style={{color: '#A9A9A9'}}>{this.state.characterCount}/{this.props.limit}</span>
            return char
        }
    }
    
    statusSymbol(){
        const {stores} = this.props
        const {store} = stores
        if (!store.online) {
            return <span className='oneLineReconnect'><strong>Reconnecting... If you reload, changes will be lost!</strong></span>
        } else if (store.saving){
            return <div> <span className='glyphicon glyphicon-refresh Spinner' style={{fontSize:15+'px', color: 'green'}}></span><span className='oneLineSaving'> Saving...</span></div>
        } else if (this.state.showSaved){
            return <span className='oneLineSaved'>Saved!</span>
        } else {
            return null
        }
    }
 
    render(){
        return (
            <FormGroup style={{marginBottom: 0+'px'}} controlId={this.props.id} >
                {/* validationState={this.getIdeaNameValidationState()}> */}
                {this.props.label &&
                    <ControlLabel>{this.props.label}</ControlLabel>
                }
                <FormControl
                    type='text'
                    onFocus={(e) => this.setState({showStatus: true})}
                    onBlur={(e) => this.setState({showStatus: false, showSaved: false})}
                    value={this.props.name}
                    placeholder={this.props.placeholder}
                    onChange={(e)=>{this.wordCount(e)}}
                    ref='test'
                />
                <FormControl.Feedback />
                
                <div className='oneLineStatusSymbol'>
                    {this.state.showStatus === true &&
                        <div>
                            {this.statusSymbol()}
                        </div>
                    }
                </div>
                
                <div className='oneLineCharCount'>
                    {this.charAmount()}
                </div>
            </FormGroup>
        )
    }
}
OneLineTextField.propTypes = {
    name: PropTypes.string,
    limit: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    label: PropTypes.string,
}

export default inject("stores")(observer(OneLineTextField))



// WEBPACK FOOTER //
// ./src/components/OneLineTextField.js